export const oilAndGasData = {
  themeColor: "#DA291C",

  breadcrumbs: [
    {
      text: "HOME",
      url: "/"
    },
    {
      text: "FOR PROS",
      url: null
    },
    {
      text: "INDUSTRIAL SOLUTIONS",
      url: "/industrial"
    },
    {
      text: "OIL & GAS",
      url: null
    }
  ],

  heroCTAs: {
    topButton: {
      text: "REQUEST SAMPLES",
      url: "/industrial/samplesrequest/"
    },
    mainButtons: [
      {
        text: "ASK A TECHNICAL SPECIALIST",
        url: "/industrial/technicalspecialist/",
        variant: "outline"
      },
      {
        text: "REQUEST A SITE ASSESSMENT",
        url: "#site-assessment-form",
        variant: "red"
      }
    ]
  },

  components: [ 
    {
      component: "cardDeck",
      variant: "vertical",
      id: "product-lines",
      eyebrow: "you Know the wd-40® brand name —",
      title: "but do you know what it can do for your oil & gas operation?",
      body: "For over 70 years, WD-40® Brand has helped industry pros tackle extreme conditions—protecting against corrosion, maintaining hydraulics, and keeping systems running. WD-40 Specialist® is built for oil & gas, with solutions that reduce wear, cut downtime, and perform in the toughest environments. With smart delivery and proven results, it helps you get the Job Done Right®—every day.",
      cards: [
        {
          id: "clean-degrease",
          image: "/img/industrial-page/new/transportation/Inustrial Solutions - Degreaser Image 2.png",
          title: "CLEANERS & DEGREASERS",
          description: "Remove grease, grime, and contaminants fast",
          linkUrl: "/products/?functionality=clean-degrease"
        },
        {
          id: "lube-penetrants",
          image: "/img/industrial-page/new/oil-and-gas/Industrial Solutions - Lubriants & Penetrants Image 2 1.png",
          title: "LUBRICANTS & PENETRANTS",
          description: "Free stuck parts and reduce friction",
          linkUrl: "/products/?functionality=lubricates%2Cpenetrate-loosen"
        },
        {
          id: "rust-solutions",
          image: "/img/industrial-page/new/Industrial Solutions - Rust Solutions Image.png",
          title: "RUST SOLUTIONS",
          description: "Stop rust and protect metal surfaces",
          linkUrl: "/products/?functionality=removes%2Clubricates%2Crestores%2Cprotects%2Cpenetrate-loosen%2Cclean-degrease"
        }
      ],
      ctaText: "BROWSE ALL INDUSTRIAL PRODUCTS",
      ctaUrl: "/products/?category=specialist"
    },
    
    {
      component: "cardDeck",
      variant: "icons",
      id: "facility-applications",
      title: "FACILITY APPLICATIONS",
      cards: [
        {
          id: "drill-rigs",
          image: "/img/industrial-page/new/oil-and-gas/Drill Rigs Icon 1.png",
          title: "Drill Rigs",
          subtitle: "Rugged protection—onshore to offshore.",
          description: 'Use <a href="/products/corrosion-inhibitor/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Corrosion Inhibitor</a> to shield exposed metal parts and fasteners from salt air, and moisture. Apply <a href="/products/penetrating-oil-flexible-straw/" target="_blank" rel="noopener noreferrer">Penetrant with EZ-REACH®</a> to loosen rusted bolts and threaded connections in hard-to-reach areas. For smooth mechanical operation, use <a href="/products/white-lithium-grease/" target="_blank" rel="noopener noreferrer">Specialist White Lithium Grease</a> on valves, linkages, and rig equipment.'
        },
        {
          id: "pump-compressor-stations",
          image: "/img/industrial-page/new/oil-and-gas/Pump & Compressor Icon 1.png",
          title: "Pump & Compressor Stations",
          subtitle: "Reduce wear. Maintain uptime.",
          description: 'Clean oil residue and grime from pump housings, piping, gaskets, and joints with <a href="/products/industrial_strength_degreaser/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Industrial-Strength Degreaser</a>. Then apply <a href="/products/white-lithium-grease/" target="_blank" rel="noopener noreferrer">White Lithium Grease</a> to moving parts like piston rods and bearings to minimize friction and extend equipment life.'
        },
        {
          id: "electrical-control-rooms",
          image: "/img/industrial-page/new/oil-and-gas/Electrical Panel Icon 1.png",
          title: "Electrical & Control Rooms",
          subtitle: "Clean and protect key components.",
          description: 'Use <a href="/products/contact-cleaner/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Contact Cleaner</a> to remove oil, condensation, and dust from circuit boards, relays, and panels—without residue or conductivity issues.'
        }
      ]
    },

    {
      component: "fullWidthCTA",
      id: "facility-map",
      title: "solutions to every area of your facility",
      buttons: [
        {
          text: "download facility map",
          url: "https://www.datocms-assets.com/10845/1725637043-facility-full-of-uses.pdf",
          isSecondary: false
        }
      ]
    },


    {
      component: "cardDeck",
      variant: "badges",
      id: "badges-card-deck",
      title: "Introducing<br>the WD-40 Brand<br>Job Done Right® System",
      subtitle: "Experience a comprehensive solution designed to protect your equipment at every stage.",
      body: "This end-to-end approach ensures optimal performance, reduces the risk of failures, and keeps your machinery running smoothly.",
      extraImages: [
        "/img/industrial-page/new/WD40 - PCLP Graphic_v3 1.png",
        "/img/industrial-page/new/WD-40 Specialist Line 2.png"
      ],
      cards: [
        {
          id: "prep-it",
          image: "/img/industrial-page/new/Industrial Solutions - Prep It - Image.png",
          title: "Prep It",
          description: "Start every job with thorough preparation"
        },
        {
          id: "clean-it",
          image: "/img/industrial-page/new/Industrial Solutions - Clean It - Image.png",
          title: "Clean It",
          description: "Clean your surface for optimal lubrication"
        },
        {
          id: "lube-it",
          image: "/img/industrial-page/new/Industrial Solutions - Lube It - Image.png",
          title: "Lube It",
          description: "Experience superior performance with the best lubrication products on the market"
        },
        {
          id: "protect-it",
          image: "/img/industrial-page/new/Industrial Solutions - Protect It - Image.png",
          title: "Protect It",
          description: "Safeguard your hard work with the trusted protection of the WD-40 Brand"
        }
      ]
    },

    {
      component: "cardDeck",
      variant: "products"
    },

    {
      component: "fullWidthCTA",
      id: "safety-efficiency",
      title: "SOLUTIONS TO MAXIMIZE SAFETY & EFFICIENCY",
      buttons: [
        {
          text: "SAFETY DATA SHEETS",
          url: "https://wd40company.com/partners-suppliers/safety-data-sheets/?region=USA",
          isSecondary: true
        },
        {
          text: "REQUEST SAMPLES",
          url: "/industrial/samplesrequest/",
          isSecondary: false
        }
      ]
    },
    {
      component: "NumberedStepsList",
      id: "trial-program",
      eyebrow: "PREP IT. CLEAN IT. LUBE IT. PROTECT IT.",
      title: "WD-40 BRAND JOB DONE RIGHT TRIAL PROGRAM",
      subtitle: "GET INDUSTRIAL-STRENGTH PERFORMANCE, PROVEN IN YOUR FACILITY.",
      body: "The WD-40 Specialist product line is built to handle the toughest maintenance challenges across industries. Now, with our Job Done Right Trial Program, you can put our solutions to the test—right on your floor, with your team, and your toughest jobs.",
      steps: [
        {
          number: "1",
          title: "ON-SITE ASSESSMENT",
          description: "Our experts visit your facility to understand your systems, challenges, and performance goals. From conveyor lines to electrical panels, we evaluate where you need support most."
        },
        {
          number: "2",
          title: "TAILORED RECOMMENDATIONS BY PRODUCT CATEGORY",
          description: "We match WD-40 Specialist solutions to your specific needs:",
          bulletPoints: [
            {
              title: "Cleaners & Degreasers",
              description: "Remove grease, grime, and contaminants fast"
            },
            {
              title: "Lubricants & Penetrants",
              description: "Free stuck parts and reduce friction"
            },
            {
              title: "Rust Solutions",
              description: "Stop rust and protect metal surfaces"
            }
          ]
        },
        {
          number: "3",
          title: "TRIAL IMPLEMENTATION",
          description: "We'll run a live trial in your environment to demonstrate product performance where it matters most—on the job. You'll receive a detailed Findings Report with key metrics, ROI, and measurable improvements."
        },
        {
          number: "4",
          title: "LONG-TERM OPTIMIZATION",
          description: "The trial is just the beginning. Our team supports your ongoing success with training, product guidance, and evolving solutions as your facility grows."
        }
      ]
    },
    {
      component: "site-assessment-form"
    },
    {
      component: "cardDeck",
      variant: 'faqs',
      id: "food-beverage-faqs",
      title: "FREQUENTLY ASKED QUESTIONS",
      cards: [
        {
          id: "faq-1",
          title: "Are WD-40® Brand products built for extreme conditions found in oil & gas operations?",
          body: "Yes. WD-40 Specialist® products are engineered to perform in high-pressure, high-temperature, and corrosive environments—onshore and offshore. Our formulas protect against saltwater exposure & heavy wear. They continue to work even in extreme temperatures, making them ideal for use on rigs, pipelines, and production equipment."
        },
        {
          id: "faq-2",
          title: "Are WD-40® Brand products compliant with safety and environmental regulations in oil & gas?",
          body: "Absolutely. All WD-40 Brand products are 50-state VOC compliant and meet key regulatory standards, including those required for industrial and energy-sector use. Many products are NSF registered or GHS-labeled, supporting safe, compliant use in safety-critical and environmentally sensitive areas."
        },
        {
          id: "faq-3",
          title: "How do WD-40® Brand solutions help extend equipment life in oil & gas environments?",
          body: "WD-40 Specialist® lubricants, penetrants, and corrosion inhibitors help reduce friction, prevent seizing, and protect metal surfaces from rust—even in harsh, wet, or dirty conditions. From valves and chains to electrical connectors and heavy mechanical linkages, our products help reduce wear and unplanned downtime—keeping assets online longer."
        }
      ],
      ctaText: "ASK A TECHNICAL SPECIALIST",
      ctaUrl: "/industrial/technicalspecialist/"
    }
  ],

};
